var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrequencyMusicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2378_6624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7096 16.275V18.7395C27.7096 19.3812 27.1846 19.9062 26.543 19.9062C25.9013 19.9062 25.3763 19.3812 25.3763 18.7395V16.275C25.3763 15.6333 25.9013 15.1083 26.543 15.1083C27.1846 15.1083 27.7096 15.6333 27.7096 16.275ZM13.0242 11.2C13.6659 11.2 14.1909 11.725 14.1909 12.3666V22.6333C14.1909 23.275 13.6659 23.8 13.0242 23.8C12.3826 23.8 11.8576 23.275 11.8576 22.6333V12.3666C11.8576 11.725 12.3826 11.2 13.0242 11.2ZM8.45964 15.1083C9.1013 15.1083 9.6263 15.6333 9.6263 16.275V18.7395C9.6263 19.3812 9.1013 19.9062 8.45964 19.9062C7.81797 19.9062 7.29297 19.3812 7.29297 18.7395V16.275C7.29297 15.6333 7.81797 15.1083 8.45964 15.1083ZM22.0659 11.2C22.7076 11.2 23.2326 11.725 23.2326 12.3666V22.6333C23.2326 23.275 22.7076 23.8 22.0659 23.8C21.4242 23.8 20.8992 23.275 20.8992 22.6333V12.3666C20.8992 11.725 21.4242 11.2 22.0659 11.2ZM17.5013 7.29163C18.143 7.29163 18.668 7.81663 18.668 8.45829V26.5416C18.668 27.1833 18.143 27.7083 17.5013 27.7083C16.8596 27.7083 16.3346 27.1833 16.3346 26.5416V8.45829C16.3346 7.81663 16.8596 7.29163 17.5013 7.29163Z",
    fill: "#4B2B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.39167C25.8271 2.39167 32.6083 9.17292 32.6083 17.5C32.6083 25.8271 25.8271 32.6083 17.5 32.6083C9.17292 32.6083 2.39167 25.8271 2.39167 17.5C2.39167 9.17292 9.17292 2.39167 17.5 2.39167ZM17.5 0C7.83125 0 0 7.83125 0 17.5C0 27.1688 7.83125 35 17.5 35C27.1688 35 35 27.1688 35 17.5C35 7.83125 27.1688 0 17.5 0Z",
    fill: "#4B2B5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2378_6624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrequencyMusicIcon);
export default __webpack_public_path__ + "static/media/frequencyMusicIcon.e217c99e42f08e63970012dc29e2b158.svg";
export { ForwardRef as ReactComponent };